import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const TrashIcon = ({ label = 'Trash', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#ef8975" d="M106.7 226.9h84.9L199 93.5H98.3l8.4 133.4z"/><path style="fill:#ee8875" d="M71.6 64.6 84.1 264h130.6l12.5-199.4H71.6z"/><path d="M214.7 269H84.1a5 5 0 0 1-5-4.7L66.6 64.9a4.7 4.7 0 0 1 1.4-3.7 4.8 4.8 0 0 1 3.6-1.6h155.6a5.2 5.2 0 0 1 3.7 1.6 5 5 0 0 1 1.3 3.7l-12.5 199.4a5 5 0 0 1-5 4.7zM88.8 259H210l11.9-189.4h-145z" style="fill:#1d1d1b"/><path d="M244.8 69.2H54.1a5 5 0 0 1-5-5 5 5 0 0 1 5-5h190.7a5 5 0 0 1 5 5 5.1 5.1 0 0 1-5 5z" style="fill:#1d1d1b"/><path d="M190.4 69.2a5 5 0 0 1-4.9-3.9l-5.2-22.6h-61.9l-5 22.6a5 5 0 0 1-9.8-2.2l5.9-26.5a4.9 4.9 0 0 1 4.9-3.9h69.9a4.9 4.9 0 0 1 4.9 3.9l6 26.5a4.9 4.9 0 0 1-3.7 5.9zm-40.8 163.9a5.1 5.1 0 0 1-5-5V95a5.1 5.1 0 0 1 5-5 5 5 0 0 1 5 5v133.1a5 5 0 0 1-5 5zm-33.2 0a5 5 0 0 1-5-4.8l-7-133a5 5 0 1 1 10-.5l7 133a5.1 5.1 0 0 1-4.8 5.3zm66.1 0h-.3a5 5 0 0 1-4.7-5.3l6.9-133a5.1 5.1 0 0 1 5.3-4.8 5 5 0 0 1 4.7 5.3l-6.9 133a5.1 5.1 0 0 1-5 4.8z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

TrashIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { TrashIcon }
